import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import InfoCircle from "../img/info-circle.svg";

const Scl90CardResults = ({ title, tooltipText, dataKey, transformedScl90List, percSex, height = 300 }) => (
  <div className="anali-el">
    <p className="anali-title">
      {title}
      <span className="tooltip" data-tooltip={tooltipText}>
      <img src={InfoCircle} alt="Información" />
      </span>
    </p>
    <div className="anali-result-container">
     
    <ResponsiveContainer width="100%" height={height}>
  <LineChart
    width={600}
    height={300}
    data={transformedScl90List}
    margin={{ top: 50, right: 0, left: -30, bottom: 0 }}
  >
    {/* Eje Y con rango de 0 a 100 y líneas de ticks */}
    <YAxis
      type="number"
      domain={
          dataKey === "totalDimenAdi"
            ? [0, 4] // Rango específico para totalDimenAdi
            : [0, 100] // Rango genérico para otros datos
        }
      axisLine={{ strokeWidth: 0 }} // Ocultar línea del eje
      tickLine={{
        stroke: "#777777", // Color de las líneas de los ticks
        strokeWidth: 1, // Grosor de las líneas
        length: 6, // Longitud de las líneas
      }}
      tick={{
        fontSize: 12,
        fill: "#777777", // Color de los números
      }}
    />
    <XAxis
      axisLine={{ strokeWidth: 0 }}
      dataKey="fecha"
      padding={{ left: 50, right: 40 }}
      dy={10}
      tick={{
        fontSize: 12,
        fill: "#777777",
      }}
    />
    <Tooltip />
    <Line
      key={dataKey}
      type="monotone"
      dataKey={dataKey}
      stroke="#29ade6"
      strokeWidth={8}
      dot={{
        r: 6,
        fill: "#29ade6",
        stroke: "#fff",
        strokeWidth: 4,
      }}
      label={(props) => {
        // Extraemos las coordenadas y el valor
        const { x, y, value, index } = props;
        // Ajustes para el rectángulo
        const bgColor = "#f7f7f7";  // Fondo blanco
        const textColor = "#29ade6";
        const fontSize = 26;
        const fontWeight = "bold";
        const padding = 0;

        // Para centrar el texto en el rectángulo, calculamos un ancho aproximado.
        // Aquí lo simplificamos, pero podrías medirlo con canvas o un aproximado por caracter.
        const textStr = String(value);
        const textWidth = textStr.length * (fontSize * 0.6); // aproximado
        const textHeight = fontSize; // El alto aproximado de la fuente

        // Posición para el rect: 
        // x - la mitad del ancho calculado, 
        // y - un poco más arriba (textHeight más algo de padding).
        const rectX = x - textWidth / 2 - padding;
        const rectY = y - 34; // subimos un poco
        const rectWidth = textWidth + padding * 2;
        const rectHeight = textHeight + padding * 2;

        return (
          <g key={`label-${index}`}>
            {/* El rectángulo de fondo */}
            <rect
              x={rectX}
              y={rectY}
              width={rectWidth}
              height={rectHeight}
              fill={bgColor}
              rx={4} // esquinas redondeadas opcionales
              ry={4}
              // stroke="#ccc" // si quieres un borde
              // strokeWidth={1} // ancho del borde
            />
            {/* El texto */}
            <text
              x={x}
              y={y - textHeight / 2 - padding / 2} 
              fill={textColor}
              fontSize={fontSize}
              fontWeight={fontWeight}
              textAnchor="middle"
            >
              {value}
            </text>
          </g>
        );
      }}
    />

  </LineChart>
</ResponsiveContainer>



    </div>
  </div>
);

export default Scl90CardResults;
